
import dayjs from "dayjs";
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import { addCurrencyUnit, addCurrencySymbol } from "@common/src/utils/tools";
import StandardFlag from "@common/src/components/scope/standard-flag/index.vue";
import t from "@common/src/i18n/t";
const finance = namespace("finance");
const base = namespace("base");
const setting = namespace("setting");
@Component({ components: { StandardFlag } })
@Table("loadListData")
export default class InvoiceManage extends Vue {
  @finance.Action getReceiptList;
  @setting.Action getPatternPaymentList;
  @base.Action getDictionaryList;
  dayjs = dayjs;
  splitThousands = splitThousands;
  emptyToLine = emptyToLine;
  addCurrencyUnit = addCurrencyUnit;
  addCurrencySymbol = addCurrencySymbol;
  searchForm = {
    receiptTimeFrom: "",
    receiptTimeTo: "",
    payerName: "",
    receiptNo: "",
    receiptType: "",
    paidMethod: "",
    createTime: [],
    createTimeFrom: "",
    createTimeTo: "",
    includeDiscount: ""
  };
  receiptList: any[] = [];
  receiptTypeList: any[] = [];
  get searchList() {
    return [
      {
        label: t("finance.receipt-time"),
        type: "timerange",
        value: "",
        prop: "paidTime",
        valueDistribute: ["paidTimeFrom", "paidTimeTo"]
      },
      {
        label: t("v213.Created-time"),
        type: "timerange",
        value: "",
        prop: "receiptTime",
        valueDistribute: ["receiptTimeFrom", "receiptTimeTo"]
      },
      {
        label: t("finance.receipt-no"),
        type: "input",
        value: "",
        prop: "receiptNo"
      },
      {
        label: t("finance.payer"),
        type: "input",
        value: "",
        prop: "payerName"
      },
      {
        label: t("finance.proceeds-type"),
        type: "select",
        selectList: this.receiptTypeList,
        value: "",
        prop: "receiptType"
      },
      {
        label: t("v210901.collection-method"),
        type: "select",
        selectList: this.receiptPaymentTypeList,
        value: "",
        prop: "paidMethod"
      },
      {
        label: "是否优惠",
        type: "select",
        selectList: [
          {
            label: "是",
            value: "1"
          },
          {
            label: "否",
            value: "0"
          }
        ],
        value: "",
        prop: "includeDiscount"
      }
    ];
  }

  created() {
    this.init();
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        this.searchForm[item.prop] = item.value;
      }
    });
    this.loadListData();
  }
  totalReceiptAmount: string = "";
  @Table.LoadDataMethod()
  loadListData() {
    return this.getReceiptList({
      orderItems: this.mix_sortParams,
      ...this.searchForm,
      pageSize: this.mix_pageSize,
      pageNum: this.mix_pageNum
    }).then(data => {
      this.totalReceiptAmount = this.$safeValue(data, "data.totalReceiptAmount");
      this.receiptList = this.$safeValue(data, "data.list", []);
      return data;
    });
  }

  handleLinkView(row) {
    const { href } = this.$router.resolve(`/finance/collection-order-view/${row.receiptNo}`);
    window.open(href);
  }
  async init() {
    this.loadListData();
    this.getDictionaryList("receipt_type").then(data => {
      this.receiptTypeList = data;
    });
    await this.getReceiptPaymentTypeList();
  }
  handleInvoice(row) {
    this.$router.push(`/service/make-invoice/${row.receiptNo}`);
  }
  // -----------------------------2.16.5
  receiptPaymentTypeList = [];
  /**
   * 获取查询条件-收款方式list
   */
  async getReceiptPaymentTypeList() {
    this.getPatternPaymentList({
      status: 1,
      scene: "30"
    }).then(data => {
      let list = this.$safeValue(data, "data", []);
      this.receiptPaymentTypeList = list.map(item => {
        return Object.assign(item, {
          label: item.payMethodName,
          value: item.payMethodCode
        });
      });
    });
  }
}
